import React from "react"
import logo from "../pageComponents/images/logo-edison.svg"

const IntroduzioneMobile = ({ backgroundColor, openPercent, color, innerRef }) => {
  return (
    <div ref={innerRef} style={{ background: backgroundColor, color: color }} className="grid-cols-4 md:grid-cols-8 min-h-100 md:h-100">
      <div className='col-4 md:col-6 md:col-offset-left-1'>
        <div className='d-flex justify-content-between mt-2'>
          <div><img width={155} src={logo} alt='Edison' /></div>
          <div className='xs:font-18 md:font-20 line-height-22 mt-2'>
            APR. 2020
          </div>
        </div>
        <div className='mt-3'>
          <div className='col-1' style={{ height: 2, backgroundColor: '#FF6B29'}}></div>
        </div>
        <div className='mt-2'>
          <div className='font-22 md:font-26 line-height-28 font-family-acumin'>
            I livelli preoccupanti di inquinamento atmosferico
            e lo sfruttamento delle risorse petrolifere obbligano
            a intervenire, con soluzione concrete, nel dibattito
            sulla convenienza dei mezzi di trasporto alimentati
            a combustibili fossili.
          </div>
          <div className='mt-2 md:mt-4 font-22 md:font-26 line-height-28 font-family-acumin'>
            La cosiddetta mobilità alternativa è diventata
            una necessità, non più solo una tendenza:
            cambiare il modo di muoversi, a tutti i livelli,
            oggi è doveroso per contribuire a un migliore
            utilizzo delle risorse.
          </div>
          <div className='mt-2 md:mt-4 mb-5 font-22 md:font-26 line-height-28 font-family-acumin'>
            Per questo Edison ha sviluppato Fleet Audit, servizio che favorisce
            la mobilità sostenibile attraverso l'analisi delle flotte e la
            successiva graduale elettrificazione.
          </div>
        </div>
      </div>
    </div>
  )
}

export default IntroduzioneMobile
